module.exports = __webpack_public_path__ + "media/images/icon-mailbox-c431f42a2bd26c69055b5760387b1929.png";